var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.detail),expression:"detail"}]},[_c('ViewDetail',{attrs:{"header":"ข้อมูลผู้สูงอายุ / ผู้ป่วย","detail":_vm.patientDetail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }